import { Search, Sparkles, ChevronDown } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const CONTEXT = {
    company: ["Meridian Retail Holdings"],
    brand: ["All Brands", "Aeon Sportswear", "Lumen Apparel", "Nova Home"],
    country: ["India"],
    period: ["This Month", "Last Month", "This Quarter", "Last 30 Days"],
    channel: ["All Channels", "MBO", "LFS", "EBO"],
};

export default function TopBar({ context, setContext, onOpenCopilot }) {
    return (
        <header
            className="flex h-14 shrink-0 items-center gap-3 border-b border-border bg-card px-4"
            data-testid="app-topbar"
        >
            <ContextPicker
                label="Company"
                value={context.company}
                options={CONTEXT.company}
                onChange={(v) => setContext({ ...context, company: v })}
                testid="ctx-company"
            />
            <ContextPicker
                label="Brand"
                value={context.brand}
                options={CONTEXT.brand}
                onChange={(v) => setContext({ ...context, brand: v })}
                testid="ctx-brand"
            />
            <ContextPicker
                label="Country"
                value={context.country}
                options={CONTEXT.country}
                onChange={(v) => setContext({ ...context, country: v })}
                testid="ctx-country"
            />
            <ContextPicker
                label="Period"
                value={context.period}
                options={CONTEXT.period}
                onChange={(v) => setContext({ ...context, period: v })}
                testid="ctx-period"
            />
            <ContextPicker
                label="Channel"
                value={context.channel}
                options={CONTEXT.channel}
                onChange={(v) => setContext({ ...context, channel: v })}
                testid="ctx-channel"
            />

            <div className="ml-auto flex items-center gap-2">
                <div className="hidden items-center gap-2 rounded-sm border border-border bg-background px-2 py-1 text-[12px] text-muted-foreground md:flex">
                    <Search className="h-3.5 w-3.5" />
                    <span>Search stores, SKUs, orders…</span>
                    <kbd className="ml-3 rounded border border-border bg-card px-1.5 py-[1px] font-mono text-[10px] text-muted-foreground">
                        ⌘K
                    </kbd>
                </div>
                <Button
                    size="sm"
                    onClick={onOpenCopilot}
                    data-testid="copilot-trigger-btn"
                    className="gap-1.5 bg-[hsl(var(--ai))] text-white hover:bg-[hsl(var(--ai))]/90"
                >
                    <Sparkles className="h-3.5 w-3.5" /> Ask Copilot
                </Button>
            </div>
        </header>
    );
}

function ContextPicker({ label, value, options, onChange, testid }) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    data-testid={testid}
                    className="group flex items-center gap-1.5 rounded-sm border border-border bg-background px-2.5 py-1 text-left text-[12px] transition-colors hover:border-foreground/30"
                >
                    <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                        {label}
                    </span>
                    <span className="ml-1 max-w-[140px] truncate font-medium text-foreground">{value}</span>
                    <ChevronDown className="h-3 w-3 text-muted-foreground transition-transform group-data-[state=open]:rotate-180" />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="min-w-[180px]">
                <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-muted-foreground">
                    {label}
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                {options.map((o) => (
                    <DropdownMenuItem
                        key={o}
                        data-testid={`${testid}-opt-${o.replace(/\s+/g, "-").toLowerCase()}`}
                        onClick={() => onChange(o)}
                        className="text-[13px]"
                    >
                        {o}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
